









import Vue, { PropOptions } from 'vue';
import { Emit } from 'vue-property-decorator';

export default Vue.extend({
  name: 'SearchBox',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    value: String,
  },
});
